import React from 'react';

/**
 * Tiny inline trend line for live widgets (WS1.2). Takes the recent numeric
 * values in time order and draws a polyline with a soft area fill; no axes.
 */
const Sparkline = ({ values = [], width = 120, height = 28, color = 'currentColor', title = 'Recent history' }) => {
  const points = values.filter((v) => typeof v === 'number' && Number.isFinite(v));
  if (points.length < 2) return null;

  const min = Math.min(...points);
  const max = Math.max(...points);
  const span = max - min || 1;
  const pad = 2;
  const stepX = (width - pad * 2) / (points.length - 1);
  const coords = points.map((v, i) => [pad + i * stepX, height - pad - ((v - min) / span) * (height - pad * 2)]);
  const line = coords.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const area = `${pad},${height - pad} ${line} ${(pad + (points.length - 1) * stepX).toFixed(1)},${height - pad}`;
  const last = coords[coords.length - 1];

  return (
    <svg
      className="sparkline"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label={`${title}: ${points.length} values from ${min.toLocaleString()} to ${max.toLocaleString()}`}
      data-points={points.length}
    >
      <polygon points={area} fill={color} opacity="0.12" />
      <polyline points={line} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={last[0]} cy={last[1]} r="2" fill={color} />
    </svg>
  );
};

export default Sparkline;
